import React from 'react'
import Text from 'react-text'
import Fade from '@mui/material/Fade'
import CancelIcon from '@mui/icons-material/Cancel'
import IconButton from '@mui/material/IconButton'
import {faFilePdf} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {Consumer} from '../../../context'
import Plan from './plan'
import {planningFilename} from 'components/standards-selector/domain/planning-filename.cjs'
import DownloadLink, {parseContext, PDFDocument} from '../pdf/plan'
import {PDFViewer} from '@react-pdf/renderer'
import './index.styl'

export default function Preview () {
  return (
    <Consumer>{context => {

      const {translate} = context
      const {project} = context.profile.institution

      const plan = parseContext(context, context.newPlan)
      const filename = planningFilename([context.translate('planning'), plan.author.name, plan.author.lastName, plan.title])
      const headerTitle = `${translate(`${project}_project_title`)} - ${translate("planning_title")}`

      return (
        <div className="planning-preview">
            <div className="preview-topbar">
              {plan.id && plan.subject && plan.grade && plan.group && (
                <DownloadLink className="print-pdf" fileName={filename} headerTitle={headerTitle} plan={plan}>
                  <label>{translate('save-pdf')}</label>
                  <FontAwesomeIcon icon={faFilePdf} />
                </DownloadLink>
              )}
              <div style={{flexGrow: 1}} />
              <IconButton
                style={{padding: 0}}
                onClick={() => {
                  context.navigate({view: context.newPlanFrom},'/:languageId/:role/:page/:view',{query: context.newPlanFromQuery})
              }}
                size="large">
                <CancelIcon />
              </IconButton>
            </div>
          {false && plan.id && <PDFViewer className="preview">
              <PDFDocument {...{...plan, headerTitle}} />
            </PDFViewer>
          }
          {true &&
          //  <Fade in={plan.id != undefined}>
            <div className="preview">
              {plan.id && (<Plan {...plan} />)}
            </div>
          // </Fade>
        }
        </div>
      );
    }}</Consumer>
  );
}
